import { render, staticRenderFns } from "./order-manag1.vue?vue&type=template&id=68cfc6e2&"
import script from "./order-manag1.vue?vue&type=script&lang=js&"
export * from "./order-manag1.vue?vue&type=script&lang=js&"
import style0 from "./order-manag1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports